<template>
  <b-modal
    id="destroy-user-modal"
    :modal-class="'default-modal'"
    :hide-footer="true"
  >
    <AlertWraper
    :content="content"
    :type="content_type"
    />
    <div class="text-center mt-3">
      <div class="mb-4">
        <i class="fa fa-warning font-size-large text-warning"></i>
      </div>
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>{{ $t('disable_user') }}</span>
        </h2>
      </div>
      <p>{{ $t('disable_the_user') }} <br><strong>{{ this.user ? this.user.name : '' }}</strong>?</p>
      <Button
        type="button"
        class="btn-color10 mt-4"
        @click="submit"
        :loading="loader"
      >
        {{ $t('disable_user') }}
      </Button>
    </div>
  </b-modal>
</template>

<script>

import UsersService from '@/modules/users/services/users-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyUserModal',
  props: ['user'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      loader: false,
      content: null,
      content_type: 'error'
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      try {
        await UsersService.destroyUser(this.user.id)
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('user_successfully_deactivated')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$bvModal.hide('destroy-user-modal')
        this.$emit('user-destroyed', this.user)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
